import React, { useState } from "react";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import DateSelect from '../../components/common/dateSelect';
import UsersImg from "../../assets/images/users.svg";
import User3Img from "../../assets/images/user-3.svg";

export default function TenantReportDashBoard(props){
    const [show, setShow] = useState(false);
    const [selectOption, setSelectOption] = useState(1);
    const [dashboardData, setTenantDashBoard] = useState({});
    
    const fetchTenantReport = async (payload = { filterType: "today" }) =>{
        await commonPostApi(API_ENDPOINTS.TENANT_REPORT_DASHBOARD,payload).then(data=>{
          setTenantDashBoard(data?.data?.data && transformData(data.data.data))
      })
    }
      
    const transformData = (data) => {
        let result = {};
        data.forEach(item => {
            if (item.surgery === "free") {
                result.free_surgery = item.count;
            } else if (item.surgery === "paid") {
                result.paid_surgery = item.count;
            } else if (item.surgery === "total") {
                result.total_surgery = item.count;
            }
        });
        return result;
    }
        
  const generatePayload = (date1, date2, selectedOption, dataGrid) => {
    const filterType = {
      1: "today",
      2: "week",
      3: "month",
      4: "custom",
    };
    const payload = {};
    payload.startDate = date1;
    payload.endDate = date2;
    payload.filterType = filterType[selectedOption];
      fetchTenantReport(payload);      
  };

    return(
    <div className="md:p-4 p-3 mt-4 mb-4 Patients__date-container">
        <DateSelect
            show={show}
            onDateRangeChange={(date1, date2, selectedOption = 1) => {
                generatePayload(date1, date2, selectedOption);
            }}
            setShow={setShow}
            selectOption={selectOption}
            setSelectOption={setSelectOption}
            
            />
        <div className="Patients__card-container">
            <ul className="tenant__card-holder md:grid-column-3fr">
                <li>
                <div className="card-left-sec">
                    <p className="card-title">Total Surgeries</p>
                    <p className="card-info">
                    <span className="total-count">
                        {dashboardData?.total_surgery || 0}
                    </span>
                    </p>
                </div>
                <div className="card-right-sec">
                    <span className="card-icon bg-one">
                    <img src={UsersImg} alt="" />
                    </span>
                </div>
                </li>
                <li>
                <div className="card-left-sec">
                    <p className="card-title">Paid Surgeries</p>
                    <p className="card-info">
                    <span className="total-count">
                        {dashboardData?.paid_surgery || 0}
                    </span>
                    </p>
                </div>
                <div className="card-right-sec">
                    <span className="card-icon bg-three">
                    <img src={User3Img} alt="" />
                    </span>
                </div>
                </li>
                <li>
                <div className="card-left-sec">
                    <p className="card-title">Free surgeries</p>
                    <p className="card-info">
                    <span className="total-count">
                        {dashboardData?.free_surgery || 0}
                    </span>
                    </p>
                </div>
                <div className="card-right-sec">
                    <span className="card-icon bg-three">
                    <img src={User3Img} alt="" />
                    </span>
                </div>
                </li>
            </ul>
        </div>
    </div>
    
    )
}